'use client';
const EventBus = ()=>{
    const eventListeners = new Map();
    const eventBus = {
        emit,
        on
    };
    function emit(eventName, ...args) {
        const listeners = eventListeners.get(eventName);
        if (!listeners) {
            return;
        }
        listeners.forEach((listener)=>listener(...args));
    }
    function on(eventName, listener) {
        if (!eventListeners.has(eventName)) {
            eventListeners.set(eventName, new Set());
        }
        const listeners = eventListeners.get(eventName);
        listeners.add(listener);
        return function unsubscribe() {
            const listeners = eventListeners.get(eventName);
            if (!(listeners == null ? void 0 : listeners.has(listener))) {
                return;
            }
            listeners.delete(listener);
            if (listeners.size === 0) {
                eventListeners.delete(eventName);
            }
        };
    }
    return eventBus;
};

export { EventBus };
//# sourceMappingURL=EventBus.js.map
